import { render } from "./Task.vue?vue&type=template&id=1d124509"
import script from "./Task.vue?vue&type=script&lang=js"
export * from "./Task.vue?vue&type=script&lang=js"

import "./Task.vue?vue&type=style&index=0&id=1d124509&scope=true&lang=css"

import exportComponent from "/Users/aryan/Task-tracker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__